import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import ProcessContent from './components/ProcessContent';

export default function ProcessPage() {
  const siteUrl = (window as any).__VITE_SITE_URL__ || 'https://kangyong.com';
  useSEO({
    title: '合作流程｜6 步驟保健食品代工合作｜康永生技',
    description: '康永生技清晰透明的 6 步驟合作流程：需求諮詢、配方提案、包裝設計、檢驗認證、量產確認到完成交貨，專人全程陪同。',
    keywords: '合作流程,代工流程,ODM流程,OEM流程,保健食品代工步驟,康永合作',
    lang: 'zh-TW',
    canonicalPath: '/cooperation/process',
  });

  return (
    <Layout>
      <SEOJsonLd type="WebPage" pageTitle="合作流程｜6 步驟保健食品代工合作｜康永生技" pageDescription="康永生技清晰透明的 6 步驟合作流程：需求諮詢、配方提案、包裝設計、檢驗認證、量產確認到完成交貨，專人全程陪同。" pageUrl={`${siteUrl}/cooperation/process`} />
      <ProcessContent />
    </Layout>
  );
}